import React, { MouseEvent } from "react";
import { Button, Icon } from "@vp/swan";
import "./ShowSocialOptionButton.scss";

interface ShowOptionButtonProps {
  onButtonClick: Function;
  buttonText: string;
  logo: any;
}

export const ShowOptionButtonControl: React.FunctionComponent<ShowOptionButtonProps> = (
  props: ShowOptionButtonProps
) => {
  const { onButtonClick, buttonText, logo } = props;

  const handleOnClick = (e: MouseEvent): void => {
    e.preventDefault();
    onButtonClick();
  };

  return (
    <Button
      data-testid="back"
      id="back-reset"
      skin="secondary"
      width="full-width"
      onClick={handleOnClick}
      iconPosition="left"
      aria-label={buttonText}
    >
      <Icon iconType={logo} />
      {buttonText}
    </Button>
  );
};

const ShowOptionButton: React.FunctionComponent<ShowOptionButtonProps> = React.memo(
  ShowOptionButtonControl
);
export default ShowOptionButton;
